<template>
	<client-only>
		<div class="ibanner">
			<div class="mainbox">
				<div class="ibanner_info wow fadeInUp">
					<div class="tit">
						<p>{{ t('home.ninzhidexinlande') }}</p>
					</div>
					<div class="con">{{ t('home.zainalizhaodaonixiangyao') }}</div>
				</div>
				<div class="search_main wow fadeInUp">
					<div class="search_nav">
						<ul>
							<li data-type="1" :class="ticketType === '1' ? 'on' : ''" @click="changeTicketType('1')">
								<p>
									<span class="tconfont tt-air"></span>
									{{ t('home.jipiao') }}
								</p>
							</li>
						</ul>
					</div>
					<div class="search_box">
						<div class="search_type">
							<ul>
								<li data-type="1" :class="tripType === '1' ? 'on' : ''" @click="changeTripType('1')">{{ t('home.dancheng') }}</li>
								<li data-type="2" :class="tripType === '2' ? 'on' : ''" @click="changeTripType('2')">{{ t('home.laihui') }}</li>
							</ul>
						</div>
						<div class="search_tool">
							<div class="search_number">
								<div v-popover="peopleRef" class="tit ep_t">{{ count }} {{ t('home.lvke') }}</div>
								<el-popover
									ref="peopleRef"
									v-model:visible="isShowPeopleSet"
									popper-class="con ep_m"
									trigger="click"
									:width="'260rem'"
									placement="bottom-start"
									transition="el-zoom-in-center"
									virtual-triggering
									persistent
									:teleported="false"
								>
									<div v-for="(item, index) in passengerListVo" :key="index" class="item">
										<div class="icon"><span :class="'tconfont ' + item.icon"></span></div>
										<div :class="item.subLabel ? 't' : 't t2'">
											{{ item.label }}
											<span v-if="item.subLabel" v-html="item.subLabel"></span>
										</div>
										<div class="num_box">
											<span :class="getEnable(index, 0) ? 'tconfont tt-reduce' : 'tconfont tt-reduce color-disable'" @click="minusNum(index)"></span>
											<input type="text" :value="item.actNum" readonly />
											<span :class="getEnable(index, 1) ? 'tconfont tt-increase' : 'color-disable tconfont tt-increase '" @click="addNum(index)"></span>
										</div>
									</div>
								</el-popover>
							</div>
							<div class="search_part">
								<div v-popover="cabinRef" class="tit ep_t">{{ convertCabinGradeName(t, curCabin) }}</div>
								<el-popover
									ref="cabinRef"
									v-model:visible="isShowCabinSet"
									popper-class="con ep_m"
									trigger="click"
									:width="'220rem'"
									placement="bottom-start"
									transition="el-zoom-in-center"
									virtual-triggering
									persistent
									:teleported="false"
								>
									<ul>
										<li v-for="item in cabinListVo" :key="item.value" :class="curCabin === item.value ? 'on' : ''" @click="selectCabin(item.value)">
											<span :class="'tconfont ' + item.icon"></span>
											{{ item.label }}
										</li>
									</ul>
								</el-popover>
							</div>
						</div>
						<div class="clear"></div>
						<div class="search_table">
							<div :class="fromCityError ? 'search_city search_form error' : 'search_city search_form'">
								<div class="search_city_t">
									<span>{{ t('home.you') }}</span>
									<input
										id="fromCityInput"
										ref="fromCityInput"
										type="text"
										autocomplete="off"
										:value="fromCityShow"
										class="input"
										:placeholder="t('tipMsg.qingshuruhuoxuanzenidechengshi')"
										@input="($event: any) => getCity(0, $event, 'fromInp')"
										@focus="($event: any) => getCity(0, $event, 'from')"
										@blur="handlerCloseCitySelect(1)"
									/>

									<div v-show="isShowFromCitySelect" class="con ep_m city_ref">
										<div v-show="!fromCityShow" class="search_city_m">
											<div class="search_city_list">
												<div v-for="(item, index) in hotCityList" :key="index" class="item">
													<div class="t">
														<span>{{ item.groupName }}</span>
													</div>
													<div class="m">
														<ul>
															<li v-for="city in item.cityList" :key="city.cityCode" @click="selectHotCity(city, 'fromCity')">{{ city.cityName }}</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div v-if="fromCityShow" v-loading="showLoading" class="search_city_inputlist">
											<div v-for="item in fromCityList" :key="item.cityCode" class="item" @click="selectCity(item, 'fromCity')">
												<div class="t">
													<p>
														<span class="tconfont tt-pos"></span>
														City
													</p>
													{{ item.cityName }}
													<i>{{ item.cityCode }}</i>
												</div>
												<div class="m">
													<ul>
														<li v-for="(airport, index) in item.airportList" :key="index">
															<span class="tconfont tt-air"></span>
															{{ airport.airportName }}
															<i>{{ airport.airportCode }}</i>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div :class="toCityError ? 'search_city search_to error' : 'search_city search_to'">
								<div class="search_city_t">
									<span>{{ t('home.dao') }}</span>
									<input
										id="toCityInput"
										ref="toCityInput"
										type="text"
										:value="toCityShow"
										class="input"
										autocomplete="off"
										:placeholder="t('tipMsg.qingshuruhuoxuanzenidechengshi')"
										@input="($event: any) => getCity(1, $event, 'retInp')"
										@focus="($event: any) => getCity(1, $event, 'ret')"
										@blur="handlerCloseCitySelect(2)"
									/>
									<div v-show="isShowToCitySelect" class="con ep_m city_ref">
										<div v-if="!toCityShow" class="search_city_m">
											<div class="search_city_list">
												<div v-for="(item, index) in hotCityList" :key="index" class="item">
													<div class="t">
														<span>{{ item.groupName }}</span>
													</div>
													<div class="m">
														<ul>
															<li v-for="city in item.cityList" :key="city.cityCode" @click="selectHotCity(city, 'toCity')">{{ city.cityName }}</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div v-if="toCityShow" v-loading="showLoading" class="search_city_inputlist">
											<div v-for="item in retCityList" :key="item.cityCode" class="item" @click="selectCity(item, 'toCity')">
												<div class="t">
													<p>
														<span class="tconfont tt-pos"></span>
														City
													</p>
													{{ item.cityName }}
													<i>{{ item.cityCode }}</i>
												</div>
												<div class="m">
													<ul>
														<li v-for="(airport, index) in item.airportList" :key="index">
															<span class="tconfont tt-air"></span>
															{{ airport.airportName }}
															<i>{{ airport.airportCode }}</i>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="search_convert" :style="{ transform: 'rotate(' + convertRotate + 'deg)' }" @click="toFromConvert"><span class="tconfont tt-convert"></span></div>
							<div v-if="showCityRepeatError" class="city_repeat_error">{{ t('home.xiangtongchengshitishi') }}</div>
						</div>
						<div :class="fromDateError || retDateError ? 'error' : ''">
							<div class="search_date">
								<div class="item search_date_1">
									<span :style="{ color: fromDateError ? '#FF0000' : '#3180FF' }">{{ t('home.chufashijian') }}</span>
									<input class="input" :value="showFromDate" :placeholder="t('login.chufariqi')" readonly="true" @click="openDatePicker(0)" />
									<el-config-provider :locale="getPickerLang()">
										<el-date-picker
											ref="fromDatePicker"
											v-model="fromDate"
											clearable
											value-format="YYYY-MM-DD"
											style="caret-color: transparent; position: absolute; top: 22rem; z-index: -1; width: 100%; height: 60rem; visibility: hidden"
											type="date"
											:disabled-date="checkFromDate"
											@change="clearError('fromDate')"
										/>
									</el-config-provider>
								</div>
								<div v-if="tripType === '2'" class="item search_date_1">
									<span :style="{ color: retDateError ? '#FF0000' : '#3180FF' }">{{ t('home.fanchengshijian') }}</span>
									<input class="input" readonly="true" :placeholder="t('login.huichengriqi')" :value="showRetDate" @click="openDatePicker(1)" />
									<el-config-provider :locale="getPickerLang()">
										<el-date-picker
											ref="toDatePicker"
											v-model="retDate"
											clearable
											value-format="YYYY-MM-DD"
											style="caret-color: transparent; position: absolute; top: 22rem; z-index: -1; width: 100%; height: 60rem; visibility: hidden"
											type="date"
											:disabled-date="checkRetDate"
											@change="clearError('retDate')"
										/>
									</el-config-provider>
								</div>
							</div>
						</div>
						<div class="clear"></div>
						<div class="search_btn">
							<button type="submit" class="btn" @click="goSearchResult">
								{{ t('home.souxun') }}
								<span class="tconfont tt-arrow"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</client-only>
</template>

<script lang="ts" setup>
// @ts-ignore
import { ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const { t, locale } = useI18n();
import { passengerTypeList } from '@/enums/passengerTypeEnum';
import { cabinGradeList, convertCabinGradeName } from '@/enums/cabinTypeEnum';
import { calculatePsgNumEnable, getAirportsList, minusPsgNum, addPsgNum } from '@/logic/home';
import { newCityInfo } from '@/logic/home/model';
import { useDebounce } from '@/utils/throttle-debounce';
import cn from 'element-plus/es/locale/lang/zh-cn';
import hk from 'element-plus/es/locale/lang/zh-tw';
import en from 'element-plus/es/locale/lang/en';
import ja from 'element-plus/es/locale/lang/ja';
import ko from 'element-plus/es/locale/lang/ko';
import { dayjs } from 'element-plus';
import { goJumpSearchResult } from '@/utils/jumpSearchResult';
import { getHotCityFun } from '@/store/locale';
import { convertDate } from '@/logic/passenger';
// const fromLaydate: any = ref(null);
// const retLaydate: any = ref(null);
const convertRotate = ref<string>('0');
let ticketType = ref<string>('1');
let tripType = ref<string>('1');
const peopleRef = ref<HTMLAllCollection>();
const cabinRef = ref<HTMLAllCollection>();
// const fromCityRef = ref<HTMLAllCollection>();
const fromCityInput = ref();
const toCityInput = ref();
const fromDatePicker = ref();
const toDatePicker = ref();
const fromCityError = ref<boolean>(false);
const toCityError = ref<boolean>(false);
const fromDateError = ref<boolean>(false);
const retDateError = ref<boolean>(false);
let isShowCabinSet = ref<boolean>(false);
let fromDate = ref<string>('');
let retDate = ref<string>('');
let toCityShow = ref<string>('');
let fromCityList: any = ref([]);
let retCityList: any = ref([]);
let toCity = ref<any>(newCityInfo());
let fromCity = ref<any>(newCityInfo());
let fromCityShow = ref<string>('');
let isShowFromCitySelect = ref<boolean>(false);
let isShowToCitySelect = ref<boolean>(false);
let isShowPeopleSet = ref<boolean>(false);
let count = ref<number>(1);
const showLoading = ref<boolean>(true);
let curCabin = ref<string>('E');
let passengerListVo = ref<any>(passengerTypeList(t));
let cabinListVo = ref<any>(cabinGradeList(t));
const showCityRepeatError = ref<boolean>(false);
const showFromDate = ref('');
const showRetDate = ref('');
onMounted(() => {});
// 设置热门城市初始化
let hotCityInfoVo: any = getHotCityFun().value || [];
const hotCityList = ref(hotCityInfoVo);
//设置日期选择显示
const openDatePicker = (type: number) => {
	switch (type) {
		case 0:
			fromDatePicker.value.handleOpen();
			break;
		case 1:
			toDatePicker.value.handleOpen();
			break;
		default:
			break;
	}
};
const getPickerLang = () => {
	return {
		Cn: cn,
		En: en,
		Hk: hk,
		Ja: ja,
		Ko: ko,
	}[locale.value];
};
// 设置购买类型
const changeTicketType = (type: string) => {
	ticketType.value = type;
};
// 设置航程类型
const changeTripType = (type: string) => {
	tripType.value = type;
};
//选择舱等
const selectCabin = (cabin: string) => {
	curCabin.value = cabin;
	isShowCabinSet.value = false;
};

const checkQueryParam = () => {
	let passCheck = true;
	if (!fromCity.value || !fromCity.value.cityCode) {
		fromCityError.value = true;
		passCheck = false;
	} else {
		fromCityError.value = false;
	}
	if (!toCity.value || !toCity.value.cityCode) {
		toCityError.value = true;
		passCheck = false;
	} else {
		toCityError.value = false;
	}
	if (fromCity.value.cityCode === toCity.value.cityCode && fromCity.value.cityCode) {
		fromCityError.value = true;
		toCityError.value = true;
		showCityRepeatError.value = true;
		passCheck = false;
	}
	if (!fromDate.value) {
		fromDateError.value = true;
		passCheck = false;
	}
	if (tripType.value === '2' && !retDate.value) {
		retDateError.value = true;
		passCheck = false;
	}
	return passCheck;
};

const goSearchResult = () => {
	if (!checkQueryParam()) {
		return;
	}
	goJumpSearchResult({
		adults: passengerListVo.value[0].actNum,
		children: passengerListVo.value[1].actNum,
		infant: passengerListVo.value[2].actNum,
		cabinGrade: curCabin.value,
		fromCityName: fromCity.value.cityName,
		fromCityCode: fromCity.value.cityCode,
		toCityName: toCity.value.cityName,
		toCityCode: toCity.value.cityCode,
		fromDate: fromDate.value,
		retDate: retDate.value,
		tripType: tripType.value,
		fromCityInfo: fromCity.value,
		toCityInfo: toCity.value,
	});
	// let url: string = 'flights/search/' + fromCity.value.cityCode + '/' + toCity.value.cityCode;
	// let queryParam = {
	// 	adults: passengerListVo.value[0].actNum,
	// 	children: passengerListVo.value[1].actNum,
	// 	infant: passengerListVo.value[2].actNum,
	// 	startDate: removeDashesFromDate(fromDate.value),
	// 	endDate: tripType.value === '2' ? removeDashesFromDate(retDate.value) : '',
	// 	tripType: tripType.value,
	// 	seatClass: curCabin.value,
	// 	currency: getSelectCurrency(),
	// };
	// if (tripType.value === '1') {
	// 	// @ts-ignore
	// 	delete queryParam['endDate'];
	// }
	// console.log(url, '', queryParam);
	// setQueryParamsFun({
	// 	adultNum: passengerListVo.value[0].actNum,
	// 	childNum: passengerListVo.value[1].actNum,
	// 	infantNum: passengerListVo.value[2].actNum,
	// 	fromCity: fromCity.value,
	// 	toCity: toCity.value,
	// 	fromDate: fromDate.value,
	// 	retDate: tripType.value === '2' ? retDate.value : '',
	// 	cabinGrades: curCabin.value,
	// 	tripType: tripType.value,
	// });
	// routeGo(url, '', queryParam);
};
watch(
	[() => getHotCityFun()],
	() => {
		hotCityList.value = getHotCityFun() || [];
	},
	{
		immediate: true,
		deep: true,
	}
);
/*
 *
 *
 */
const selectCity = (item: any, type: string) => {
	switch (type) {
		case 'fromCity':
			isShowFromCitySelect.value = false;
			fromCityList.value = [item];
			if (fromCity.value.cityCode !== item.cityCode) {
				showCityRepeatError.value = false;
			} else {
				isShowFromCitySelect.value = false;
				return;
			}
			fromCity.value = item;
			fromCityShow.value = item.cityName;
			fromCityError.value = false;
			break;
		case 'toCity':
			isShowToCitySelect.value = false;
			retCityList.value = [item];
			if (toCity.value.cityCode !== item.cityCode) {
				showCityRepeatError.value = false;
			} else {
				isShowToCitySelect.value = false;
				return;
			}
			toCity.value = item;
			toCityShow.value = item.cityName;
			toCityError.value = false;
			break;

		default:
			break;
	}
};

const selectHotCity = (item: any, type: string) => {
	isShowFromCitySelect.value = false;
	isShowToCitySelect.value = false;
	getAirportsList(locale.value.toLowerCase(), item.cityName).then(res => {
		for (let i in res) {
			if (res[i].cityCode === item.cityCode) {
				if (type === 'fromCity') {
					if (fromCity.value.cityCode !== item.cityCode) {
						showCityRepeatError.value = false;
					} else {
						isShowFromCitySelect.value = false;
						return;
					}
					fromCity.value = res[i];
					fromCityList.value = res;
					fromCityShow.value = item.cityName;
					fromCityError.value = false;
				} else {
					if (toCity.value.cityCode !== item.cityCode) {
						showCityRepeatError.value = false;
					} else {
						isShowToCitySelect.value = false;
						return;
					}
					toCity.value = res[i];
					retCityList.value = res;
					toCityShow.value = item.cityName;
					toCityError.value = false;
				}
			}
		}
		if (type === 'fromCity') {
			fromCityList.value = res;
		} else {
			retCityList.value = res;
		}
	});

	// 和普通城市选择一样的处理逻辑
	// switch (type) {
	// 	case 'fromCity':
	// 		if (fromCity.value.cityCode !== item.cityCode) {
	// 			showCityRepeatError.value = false;
	// 		} else {
	// 			isShowFromCitySelect.value = false;
	// 			return;
	// 		}
	// 		// fromCity.value = item;
	// 		fromCityShow.value = item.cityName;
	// 		isShowFromCitySelect.value = false;
	// 		fromCityError.value = false;
	// 		break;
	// 	case 'toCity':
	// 		if (toCity.value.cityCode !== item.cityCode) {
	// 			showCityRepeatError.value = false;
	// 		} else {
	// 			isShowToCitySelect.value = false;
	// 			return;
	// 		}
	// 		// toCity.value = item;
	// 		toCityShow.value = item.cityName;
	// 		isShowToCitySelect.value = false;
	// 		toCityError.value = false;
	// 		break;

	// 	default:
	// 		break;
	// }
};

const getAirportsListFun = useDebounce((type: number, str: string) => {
	showLoading.value = true;
	getAirportsList(locale.value.toLowerCase(), str).then(res => {
		if (type === 0) {
			fromCityList.value = res;
		} else {
			retCityList.value = res;
		}
		setTimeout(() => {
			showLoading.value = false;
		});
	});
}, 500);
const handlerCloseCitySelect = (type: number) => {
	setTimeout(() => {
		if (type === 1) {
			isShowFromCitySelect.value = false;
		}
		if (type === 2) {
			isShowToCitySelect.value = false;
		}
	}, 200);
};
async function getCity(type: number, e: any, routeType: string) {
	if (routeType === 'from') {
		isShowFromCitySelect.value = true;
	}
	if (routeType === 'ret') {
		isShowToCitySelect.value = true;
	}
	if (type === 0) {
		fromCityShow.value = e.target.value;
	}
	if (type === 1) {
		toCityShow.value = e.target.value;
	}
	if (!e.target.value) {
		fromCityList.value = [];
		retCityList.value = [];
		//针对是否加载中统一封装
		if (type === 0) {
			fromCity.value = {
				cityCode: '',
				cityName: '',
			};
		}
		if (type === 1) {
			toCity.value = {
				cityCode: '',
				cityName: '',
			};
		}
		showLoading.value = false;
		return;
	}
	console.log(e.type);
	if (e.type === 'focus') {
		if (type === 0) {
			let input = document.getElementById('fromCityInput') as HTMLInputElement; //获取dom对象
			let value = input?.value; //获取input的值
			console.log(value.length);
			input?.setSelectionRange(0, 0);
			input?.setSelectionRange(0, value.length);
		} else if (type === 1) {
			let input = document.getElementById('toCityInput') as HTMLInputElement; //获取dom对象
			let value = input?.value; //获取input的值
			input?.setSelectionRange(0, 0);
			input?.setSelectionRange(0, value.length);
		}
	}
	if (e.type === 'input') {
		getAirportsListFun(type, e.target.value);
		if (type === 0) {
			fromCity.value = {
				cityCode: '',
				cityName: '',
			};
		}
		if (type === 1) {
			toCity.value = {
				cityCode: '',
				cityName: '',
			};
		}
	} else if ((type === 0 && fromCityList.value.length === 0) || (type === 1 && retCityList.value.length === 0)) {
		getAirportsListFun(type, e.target.value);
	}
}

// 计算乘客人数增减是否可用，需要注意ticketType与passenger的对应关系，目前没有强制关系，枚举值更换后需要修改逻辑
const getEnable = (passengerType: number, addType: number) => {
	//拷贝统一使用泛型的方法
	let tempPsgList = JSON.parse(JSON.stringify(passengerListVo.value));
	return calculatePsgNumEnable(tempPsgList, passengerType, addType, ticketType.value, count.value);
};
const minusNum = (type: number) => {
	if (!getEnable(type, 0)) {
		return;
	}
	let tempPsg = JSON.parse(JSON.stringify(passengerListVo.value));
	const tempResult = minusPsgNum(type, tempPsg);
	count.value = tempResult.count;
	passengerListVo.value = tempResult.list;
};
const addNum = (type: number) => {
	if (!getEnable(type, 1)) {
		return;
	}
	let tempPsg = JSON.parse(JSON.stringify(passengerListVo.value));
	const tempResult = addPsgNum(type, tempPsg);
	count.value = tempResult.count;
	passengerListVo.value = tempResult.list;
};
const clearError = (type: string) => {
	switch (type) {
		case 'fromDate':
			showFromDate.value = convertDate(fromDate.value, locale.value);
			fromDateError.value = false;
			break;
		case 'retDate':
			showRetDate.value = convertDate(retDate.value, locale.value);
			retDateError.value = false;
			break;

		default:
			break;
	}
};
const toFromConvert = () => {
	let tempCity = JSON.parse(JSON.stringify(toCity.value));
	toCity.value = JSON.parse(JSON.stringify(fromCity.value));
	toCityShow.value = toCity.value.cityName;
	fromCity.value = tempCity;
	fromCityShow.value = fromCity.value.cityName;
	convertRotate.value = convertRotate.value === '0' ? '180' : '0';
};
const checkFromDate = (time: Date) => {
	if (!retDate.value) {
		return time.getTime() < dayjs().startOf('day').valueOf();
	} else {
		return time.getTime() > dayjs(retDate.value).valueOf() || time.getTime() < dayjs().startOf('day').valueOf();
	}
};
const checkRetDate = (time: Date) => {
	return fromDate.value ? time.getTime() < dayjs(fromDate.value).valueOf() : time.getTime() < dayjs().startOf('day').valueOf();
};
</script>
<style lang="scss" scoped>
.search_city_m {
	position: relative;
	box-shadow: none;
	background-color: transparent;
	display: block;
	border: none;
}
.search_city_inputlist {
	display: block;
	min-height: 400rem;
	max-height: 400rem;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 4px;
		border-radius: 2px;
		background-color: #eee;
	}
	&::-webkit-scrollbar-thumb {
		background-color: #ccc;
		border-radius: 10px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: #555;
	}
}
.color-disable {
	color: #ececec !important;
	border-color: #ececec !important;
}
.city_repeat_error {
	position: absolute;
	color: #ff0000;
	bottom: -30rem;
	font-size: 14rem;
}
.el-popover {
	margin-top: auto;
}
.search_city_list .item .t span {
	padding-bottom: 3rem;
	border-bottom: 2rem solid #a8c6ff;
}
.search_form {
	:deep(.city_ref) {
		top: 120px !important;
		min-width: 480px;
	}
}
.search_to {
	:deep(.city_ref) {
		top: 120px !important;
		min-width: 480px;
	}
}
</style>
